import { CopyFilled } from '@ant-design/icons';
import { CSSProperties, FC, MouseEventHandler } from 'react';

export interface CloneIconProps {
  className?: string;
  style?: CSSProperties;
  htmlColor?: string;
  titleAccess?: string;
  fontSize?: number | string;
  onClick?: MouseEventHandler<HTMLSpanElement>;
  'data-testid'?: string;
}

/** MUI SvgIcon / IconButton default in tables */
const DEFAULT_ICON_SIZE = 20;

export const CloneIcon: FC<CloneIconProps> = ({
  className,
  style,
  htmlColor = '#4F5863',
  titleAccess,
  fontSize = DEFAULT_ICON_SIZE,
  onClick,
  'data-testid': dataTestId,
}) => {
  return (
    <CopyFilled
      className={className}
      title={titleAccess}
      onClick={onClick}
      data-testid={dataTestId}
      style={{
        color: htmlColor === 'grey' ? '#4F5863' : htmlColor,
        fontSize,
        ...style,
      }}
    />
  );
};
